<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<ng-template #modalcreardirectorio let-modal>
    <mat-dialog-content>
        <div class="modal-header text-center">
            <div class="headerm">
                <mat-icon aria-hidden="false" aria-label="Example home icon">report</mat-icon>
                <h5 class="modal-title">
                    <div [innerHTML]="'Creación nuevo directorio'"></div>
                </h5>
            </div>

            <button id="confirmacion_cerrar" type="button" class="close" aria-label="Close" [mat-dialog-close]="false">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
            <div [formGroup]="form">
                <div class="col-md-12 col-lg-12 col-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Directorio</mat-label>
                        <input matInput formControlName="directorio" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center" *ngIf="!mostrarCargando">
        <button id="confirmacion_no" type="button" class="btn btn-primary" [mat-dialog-close]="false">Cancelar</button>
        <button id="confirmacion_si" type="button" class="btn btn-danger" (click)="CrearCarpetaConfirmacion()">Crear</button>
    </mat-dialog-actions>
</ng-template>

<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.TituloOpcionMenu()}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div [formGroup]="form" class="d-flex flex-row contenedorprincipalsubir" autocomplete="off">
        <div class="rutas">
            <div>
                <p>Página principal</p>
                <hr class="rounded mt-2">
            </div>
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" *ngIf="!mostrarCargando">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <a type="button" (click)="CambiarSeleccionRegistro(node.id, node.idFilter)" style="margin-left: 25px !important;">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{EstaSeleccionado(node.id) ? 'folder_open' : 'folder'}}
                        </mat-icon>
                        {{node.item}}
                    </a>
                </mat-tree-node>

                <mat-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <a type="button" (click)="CambiarSeleccionRegistro(node.id, node.idFilter)">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}
                        </mat-icon>
                        {{node.item}}
                    </a>
                </mat-tree-node>
            </mat-tree>
        </div>
        <div class="contenidodetalle d-flex flex-column">
            <div>
                <p class="titulodatosseleccionados">
                    Repositorio / {{itemSeleccionado.descripcion}} / {{descripcionRutaSeleccionada}}
                </p>
            </div>
            <div class="p-2" *ngIf="!mostrarCargando">
                <div fxFlex="auto" fxLayout="row" class="row pr-0 pl-0 align-items-center">
                    <div class="col-md-2 col-lg-2 col-12" *ngIf="this.itemSeleccionado.subirArchivo">
                        <button mat-button class="btnprimary crearafil" (click)="AbrirCargarArchivo()">
                            <span>Cargar</span>
                            <mat-icon>cloud_upload</mat-icon>
                        </button>
                        <input type="file" multiple #uploadFile [accept]="this.itemSeleccionado.filtroArchivos" style="display: none;" (change)="ArchivoSeleccionar($event.target.files)">
                    </div>
                    <div class="col-md-1 col-lg-1 col-12 linea" *ngIf="this.itemSeleccionado.subirArchivo">
                        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="47" viewBox="0 0 2 47">
                            <line id="Línea_69" data-name="Línea 69" y2="47" transform="translate(1)" fill="none" stroke="#707070" stroke-width="2"/>
                        </svg>
                    </div>
                    <div class="col-md-2 col-lg-2 col-12" *ngIf="this.itemSeleccionado.subdirectorios">
                        <button mat-button class="btnprimary agregarcarpeta" (click)="CrearCarpeta()">
                            <span>Crear</span>
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div class="col-md-1 col-lg-1 col-12">
                        <button mat-button [matMenuTriggerFor]="menuAdicional">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menuAdicional="matMenu">
                            <button mat-menu-item (click)="EliminarArchivosSeleccionados()" *ngIf="this.itemSeleccionado.eliminar">
                                <mat-icon>delete</mat-icon>
                                <span>Eliminar</span>
                            </button>
                            <button mat-menu-item (click)="DescargarArchivosSeleccionados()">
                                <mat-icon>cloud_download</mat-icon>
                                <span>Descargar</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
            <div *ngIf="!mostrarCargando">
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceArchivos" matSort class="table table-striped table-hover">
                            <!-- Si tiene columna de checkbox -->
                            <ng-container matColumnDef="select">
                                <tr>
                                    <th mat-header-cell *matHeaderCellDef>
                                        <mat-checkbox (change)="$event ? TodosSeleccionar() : null" [checked]="Checkeados.hasValue() && EstanTodosSeleccionados()" [indeterminate]="Checkeados.hasValue() && !EstanTodosSeleccionados()" [aria-label]="checkboxLabel()">
                                        </mat-checkbox>
                                    </th>
                                    <td mat-cell *matCellDef="let row; let _Pos = index;">
                                        <mat-checkbox (click)="$event.stopPropagation()" (change)="MarcarDesmarcarUno($event, row, _Pos)" [checked]="Checkeados.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                        </mat-checkbox>
                                    </td>
                                </tr>
                            </ng-container>
                            <!-- Nombre Column -->
                            <ng-container matColumnDef="nombreArchivo">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"> Nombre</th>
                                <td mat-cell *matCellDef="let row">
                                    <a type="button" (click)="BuscarCarpetaPrincipal(row.nombreArchivo)" *ngIf="row.esDirectorio">
                                        <mat-icon class="mat-icon-rtl-mirror marginicon">
                                            folder
                                        </mat-icon>
                                        <p>{{row.nombreArchivo}}</p>
                                    </a>
                                    <p *ngIf="!row.esDirectorio">{{row.nombreArchivo}}</p>
                                </td>
                            </ng-container>
                            <!-- fecha Column -->
                            <ng-container matColumnDef="fecha">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha</th>
                                <td mat-cell *matCellDef="let row"> {{row.fecha | date:"dd-MM-yyyy hh:mm:ss"}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen registros </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-12" style="text-align: right;">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
            <div *ngIf="this.itemSeleccionado.subirArchivo && !mostrarCargando">
                <div class="containerupload" appDnd (fileDropped)="ArchivoSeleccionar($event)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
                        <g fill="#3B454F" fill-rule="nonzero">
                            <path
                                d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                            <path
                                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                            <path
                                d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
                        </g>
                    </svg>

                    <h6>Arrastra y suelta archivos en esta ventana para cargarlos.</h6>
                    <p>Almacene aqui solo los datos autorizados de acuerdo a la politica de datos y los acuerdos de servicio, cualquier otra información podrá ser eliminada.</p>
                </div>
            </div>
        </div>
    </div>
</div>